
export default {
  'maps': {
    'pageTitle': 'CycleAI',
    'Places': 'Lieux',
    'isochrones': 'Isochrones',
    'placeNameRequired': 'Nom de lieu requis',
    'altitude': 'Variation d\'altitude',
    'settings': 'Réglages',
    'toggleAccessibleMode': 'Basculer en mode accessible',
    'aboutTitle': 'À propos d\'ORS',
    'updateSearch': 'Rechercher dans cette zone',
    'updateSearchAfterZoomOrCenterChange': 'Mettre à jour la recherche après un changement de zoom ou de centre'
  },
}
